import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Typography, useTheme } from 'hephaestus/web';
import {
  FUND_REDEMPTION_RESULT_FIELDS,
  POSITION_RESULT_FIELDS,
} from '../calculator.constants';
import type { RedemptionFundResult } from '../calculator.types';
import { CalculatorResultFields } from './calculatorResultFields';

export const CalculatorFundResultCard = ({
  expanded,
  fundName,
  hideWithholdingTax,
  labels,
  onToggle,
  options,
  source,
}: {
  expanded: boolean;
  fundName: string;
  hideWithholdingTax: boolean;
  labels: Record<string, string>;
  onToggle: () => void;
  options: Record<string, unknown>;
  source?: Partial<RedemptionFundResult>;
}) => {
  const theme = useTheme();

  return (
    <>
      <Box
        data-testid={`calculator-fund-position-result-${fundName}`}
        sx={{
          borderRadius: theme.borderRadius.sm,
          px: 2.5,
          py: 2,
          bgcolor: theme.color.surfaceContainer,
        }}
      >
        <Box
          onClick={onToggle}
          role='button'
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              onToggle();
            }
          }}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
            cursor: 'pointer',
          }}
        >
          <Typography variant='bodyMedium' sx={{ fontWeight: 600 }}>
            {fundName}
          </Typography>
          {expanded ? (
            <ExpandLessIcon
              fontSize='small'
              sx={{
                color: theme.color.primaryPressed,
              }}
            />
          ) : (
            <ExpandMoreIcon
              fontSize='small'
              sx={{
                color: theme.color.primaryPressed,
              }}
            />
          )}
        </Box>
        {expanded && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <CalculatorResultFields
              fields={POSITION_RESULT_FIELDS}
              hideWithholdingTax={hideWithholdingTax}
              labels={labels}
              options={options}
              source={source}
            />
          </Box>
        )}
      </Box>
      {expanded && (
        <Box
          data-testid={`calculator-fund-result-${fundName}`}
          sx={{
            borderRadius: theme.borderRadius.sm,
            px: 2.5,
            py: 2,
            bgcolor: theme.color.surfaceContainer,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <CalculatorResultFields
              fields={FUND_REDEMPTION_RESULT_FIELDS}
              hideWithholdingTax={hideWithholdingTax}
              labels={labels}
              options={options}
              source={source}
            />
          </Box>
        </Box>
      )}
    </>
  );
};
